import React, { FC } from 'react'

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid'

import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { FileRow } from '@/features/FileManager/FileRow'
import {
  DEFAULT_HEADINGS,
  FileManagerFile,
  setIsICSDocGenerated,
  setOrderBy,
} from '@/features/FileManager/fileManagerSlice'

interface FilesViewerListProps {
  files: FileManagerFile[]
}

export const FilesViewerList: FC<FilesViewerListProps> = ({ files }) => {
  const dispatch = useAppDispatch()

  const orderBy = useAppSelector((state) => state.fileManager.orderBy)

  const handleOrderChanged = (key: string) => {
    const { label, order } = orderBy
    const nextOrder = order === 'asc' ? 'desc' : 'asc'

    if (label === key) {
      dispatch(setOrderBy({ label, order: nextOrder }))
    } else {
      dispatch(setOrderBy({ label: key, order: nextOrder }))
    }
  }

  dispatch(
    setIsICSDocGenerated(files.some((file) => file?.fileName?.includes('Closing Statement')))
  )

  return (
    <div className='w-full flex flex-col'>
      <div className='flex justify-start items-center border-b'>
        {DEFAULT_HEADINGS.map(({ key, name }, index) => (
          <div
            onClick={() => handleOrderChanged(key)}
            key={key}
            style={{ width: index !== 0 ? '170px' : 'auto' }}
            className={`flex justify-center h-[36px] py-2 border-l cursor-pointer items-center font-bold ${
              index === 0 && 'flex-1'
            }`}
          >
            {name}
            {orderBy.label === key &&
              (orderBy.order === 'asc' ? (
                <ChevronUpIcon width={20} />
              ) : (
                <ChevronDownIcon width={20} />
              ))}
          </div>
        ))}
      </div>
      <div className='overflow-y-auto pb-40'>
        {files.map((file) => (
          <FileRow
            key={file.uuid}
            file={file}
          />
        ))}
      </div>
    </div>
  )
}
